import MarsCanvas from "@marsjs/components/lib/Canvas";
import MarsSwitch from "@marsjs/components/lib/Switch";
import MarsPicker from "@marsjs/components/lib/Picker";
import MarsVideo from "@marsjs/components/lib/Video";
import MarsSwiperItem from "@marsjs/components/lib/SwiperItem";
import MarsSwiper from "@marsjs/components/lib/Swiper";
import MarsScrollView from "@marsjs/components/lib/ScrollView";
import MarsInput from "@marsjs/components/lib/Input";
import MarsButton from "@marsjs/components/lib/Button";
import MarsForm from "@marsjs/components/lib/Form";
import MarsTextarea from "@marsjs/components/lib/Textarea";
import MarsRichText from "@marsjs/components/lib/RichText";
import MarsImage from "@marsjs/components/lib/Image";
import MarsNavigator from "@marsjs/components/lib/Navigator";
import MarsText from "@marsjs/components/lib/Text";
import MarsView from "@marsjs/components/lib/View";
export default basicComponents;
function basicComponents(Vue) {
  Vue.component("MarsView", MarsView);
  Vue.component("MarsText", MarsText);
  Vue.component("MarsNavigator", MarsNavigator);
  Vue.component("MarsImage", MarsImage);
  Vue.component("MarsRichText", MarsRichText);
  Vue.component("MarsTextarea", MarsTextarea);
  Vue.component("MarsForm", MarsForm);
  Vue.component("MarsButton", MarsButton);
  Vue.component("MarsInput", MarsInput);
  Vue.component("MarsScrollView", MarsScrollView);
  Vue.component("MarsSwiper", MarsSwiper);
  Vue.component("MarsSwiperItem", MarsSwiperItem);
  Vue.component("MarsVideo", MarsVideo);
  Vue.component("MarsPicker", MarsPicker);
  Vue.component("MarsSwitch", MarsSwitch);
  Vue.component("MarsCanvas", MarsCanvas);
}